<template>
  <li :class="['faq', { '--open': isOpen }]" v-reveal>
    <div class="faq__top" @click="isOpen = !isOpen">
      <Image v-if="image" :source="image" class="faq__icon" />
      <h3 class="faq__title">{{ content.question }}</h3>
      <Icon id="drop-arrow" />
    </div>
    <DropDown :is-open="isOpen">
      <RawHtml :html="content.answer" class="faq__answer" />
    </DropDown>
  </li>
</template>

<script>
import { DropDown, Icon, Image, RawHtml } from '@/components/global'
import { HasContentMixin } from '@/mixins'

export default {
  name: 'FaQuestion',
  mixins: [HasContentMixin],
  props: {
    image: {
      type: String,
      default: null
    }
  },
  components: { DropDown, Icon, Image, RawHtml },
  data() {
    return {
      isOpen: false
    }
  }
}
</script>